$(window).on("load", async function () {

    // console.log($(window).width())

  
  
  
  
  const parser = new DOMParser();
  let doc = await parser.parseFromString(productDescription, "text/html");
  
//     console.log(doc);
  
//   console.log($('p', [doc]))
  
//   Sift/Split Data
  let allTitles = $('p', [doc])
//   let allChildren = $('', [doc]).children('ul')
  let allContents = $('body > ul', [doc])
  
//   console.log(allTitles)
//   console.log(allContents)
  
//   Generate # of tabs and # of accordion-tabs based on input...
  
  
  //Create Tab Titles
  
  for (let index = 0; index < allTitles.length; index++) {
    
//     console.log(allTitles[index])
//     console.log(allContents[index])
    
    //Create Elements
    let accordionBox = document.createElement("div");
    let accordionHead = document.createElement("div");
    let accordionTitleAlign = document.createElement("div");
    let accordionOverlineDivider = document.createElement("div");
    let accordionArrowAlign = document.createElement("div");
    let accordionContent = document.createElement("div");
    let accordionContentHolder = document.createElement("div");
    let accordionArrow = document.createElement("img");

    console.log(accordionArrowGlobalSRC)
    
    //Set Classes
    accordionBox.setAttribute("id", `accordion-box-${index}`)
    accordionBox.setAttribute("class", "accordion-each")
    accordionHead.setAttribute("class", "head-accordion")
    accordionTitleAlign.setAttribute("class", "accordion-title-align")
    accordionOverlineDivider.setAttribute("class", "overline-divider-accordion")
    accordionArrowAlign.setAttribute("class", "accordion-arrow-align")
    accordionArrow.setAttribute("class", "acc-arrow")
    accordionArrow.setAttribute("src", accordionArrowGlobalSRC)
    accordionContent.setAttribute("class", "content-accordion")
    accordionContentHolder.setAttribute("class", "acc-content-holder")
    
    // Nest Elements
    
    accordionOverlineDivider.append(allTitles[index])
    accordionTitleAlign.append(accordionOverlineDivider)
    accordionArrowAlign.append(accordionArrow)
    
    
    accordionHead.append(accordionTitleAlign)
    accordionHead.append(accordionArrowAlign)
    
    accordionContentHolder.append(allContents[index])
    accordionContent.append(accordionContentHolder)
    
    accordionBox.append(accordionHead)
    accordionBox.append(accordionContent)
    
    $('.container-accordion-custom').append(accordionBox)
    
   
}
  
  
  
//   <div id="accordion-box-1" class="accordion-each"><!-- Accordion Head -->
// <div class="head-accordion">
// <!-- <div class="accordion-image-align"><img src="./images/aerosol-test-svg.svg" class="icon-accordion"></div> -->
// <div class="accordion-title-align">
// <div class="overline-divider-accordion"><hr>
// <p>Description</p>
// </div>
// </div>
// <div class="accordion-arrow-align"><img src="{{'triangle-arrow-smaller-container.svg' | asset_url}}" class="acc-arrow"></div>
// </div>
// <!-- End Of Accordion Head --> <!-- Accordion Content -->
// <div class="content-accordion"><!-- Cannot style "display: block;" -->
// <div class="acc-content-holder">
// <ul>
//         <li>blox surgical N95 respirators are approved for medical use & certified by the National Institute for Occupational Safety and Health (NIOSH), part of the CDC under TC-84A-IVW2360. </li>
//         <li>bloxN95 respirators provide >99% filtration efficiency. These respirators are single-use disposable devices intended to be worn by operating room personnel and other health care workers to protect the professional and the patient by reducing the exposure to airborne contaminates, and the transfer of microorganisms, body fluids and particulates. </li>
//         <li>bloxN95 provides a comfortable 360-degree seal to give you the top-of-the-line protection you need on the frontlines.</li>
//         <li>Proudly manufactured in the USA at our FDA-registered facility certified to ISO 13485 in Newport News, Virginia.</li>
//       </ul>
// </div>
// </div>
// <!-- End of Accordion Content --></div>
// <!-- End of Accordion Box 1 -->
  
  
  
  
  
  



    $('.head-accordion').click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).parent().find('.acc-arrow').removeClass('arrow-animate');
            $(this).parent().find('.content-accordion').slideUp(280);
        } else {
            $(this).addClass('active');
            $(this).parent().find('.acc-arrow').addClass('arrow-animate');
            $(this).parent().find('.content-accordion').slideDown(280);
        }

        let convertToDomElement = $(this)[0];
        $('.head-accordion').not(this).removeClass('active');
        $('.head-accordion').not(this).parent().find('.acc-arrow').removeClass('arrow-animate');
        $('.head-accordion').not(this).parent().find('.content-accordion').slideUp(280).promise().done(function () {
            // will be called when all the animations on the queue finish

            // console.log(convertToDomElement);
//             if ($(window).width() < 768) {
//                 convertToDomElement.scrollIntoView(true, { behavior: 'smooth' })
//             }
        });


    });


})